import HouseList from '../components/HouseList';
import React from 'react';
import Search from '../components/Search'
const Home = () => {
  return <div >
        <Search/>
        <HouseList/>
  </div>;
};

export default Home;
